<div *ngIf="itemsQuantity>0 && !isLoading" class="more-reports">
    <p>Estas viendo {{itemsQuantity}} de {{totalElements}} reportes</p>
    <button *ngIf="page<totalPages && (!isMobile() || isStatic)" type="button" class="btn-load" (click)="onLoadPage()">Cargar</button>
</div>
<div class="search-results" *ngIf="isMobile() && !isStatic" [infiniteScrollContainer]="selector" [fromRoot]="fromRoot" infiniteScroll
    [infiniteScrollDistance]="2" [infiniteScrollThrottle]="2000" (scrolled)="onLoadPage()"></div>
<app-scrolldown-button [scrollDown]="1000"></app-scrolldown-button>
